import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CardsList from './CardsList';
import $ from 'jquery';

import './style.scoped.scss';

const Menu = ({
  rightNav,
  contentType,
  isPreview,
  currentDocument,
  handlePageChange,
  handleComparisonDocument,
  handleGlossarySelected,
  accountPage,
  handleSetFAQ,
  handlePreviousVersion,
  handleSummary,
}) => {
  const [activeCard, setActiveCard] = useState(null);

  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip();
  });

  return (
    <div id='menu-outer-wrapper'>
      <div id='menu'>
        <button
          className='wf-menu tabIndex-btn'
          id='dropdownMenuButton'
          data-toggle='dropdown'
          aria-haspopup='true'
          aria-expanded='false'
          tabIndex={0}
        >
          Menu
        </button>
        <div className='dropdown-menu'>
          {!accountPage && rightNav
            ? rightNav.map((card, i) => {
                if (
                  card === 'About' &&
                  !(
                    currentDocument.versionDate ||
                    currentDocument.registrationDate
                  )
                ) {
                  return null;
                } else
                  return (
                    <button
                      key={i}
                      className={`dropdown-item${
                        isPreview &&
                        card !== 'Assistance' &&
                        card !== 'Translate' &&
                        card !== 'Glossary' &&
                        card === 'Revealr AI' &&
                        !currentDocument.summary &&
                        'd-none'
                          ? ' dropdown-item__item-preview'
                          : ' active-override'
                      }`}
                      type='button'
                      data-toggle={
                        isPreview &&
                        card !== 'Assistance' &&
                        card !== 'Translate' &&
                        card !== 'Glossary'
                          ? 'tooltip'
                          : ''
                      }
                      title={
                        isPreview &&
                        card !== 'Assistance' &&
                        card !== 'Translate' &&
                        card !== 'Glossary'
                          ? 'Only available when document is published.'
                          : ''
                      }
                      onClick={
                        !isPreview
                          ? () => setActiveCard(card)
                          : (isPreview && card === 'Assistance') ||
                            (isPreview && card === 'Translate') ||
                            (isPreview && card === 'Glossary')
                          ? () => setActiveCard(card)
                          : null
                      }
                    >
                      {card.match('PDF')
                        ? 'Download'
                        : card.match('RevealrAI')
                        ? 'Revealr AI'
                        : card}
                    </button>
                  );
              })
            : ['Assistance', 'Translate'].map((card, i) => (
                <button
                  key={i}
                  className={`dropdown-item active-override`}
                  type='button'
                  onClick={() => setActiveCard(card)}
                >
                  {card}
                </button>
              ))}
        </div>
      </div>

      {activeCard && (
        <CardsList
          handlePageChange={handlePageChange}
          handleComparisonDocument={handleComparisonDocument}
          handleGlossarySelected={handleGlossarySelected}
          contentType={contentType}
          activeCard={activeCard}
          handleDismiss={() => setActiveCard(null)}
          handleSetFAQ={handleSetFAQ}
          handlePreviousVersion={handlePreviousVersion}
          handleSummary={handleSummary}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  rightNav: state.client.rightNav,
  isPreview: state.client.isPreview,
  currentDocument: state.document.currentDocument,
});

const connector = connect(mapStateToProps, null);

export default connector(Menu);
